const VendorFilterStyle = ({
    firstLabel: { paddingBottom: '16px' },
    restLabel: {
        paddingTop: '32px',
        paddingBottom: '16px',
    },
});

export default VendorFilterStyle;
